/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React, { useState } from 'react';
import './ContactPage.css';

const DEPARTMENTS = [
  {
    dept: 'Management',
    city: 'General',
    person: 'Joe · Mastered Trax',
    email: 'joe@masteredtrax.com',
    phone: '+1 (408) 499-7909',
    phoneHref: 'tel:+14084997909',
  },
  {
    dept: 'USA Booking',
    city: 'United States',
    person: 'Booking Team',
    email: 'booking@masteredtrax.com',
    phone: null,
    phoneHref: null,
  },
  {
    dept: 'MX Booking',
    city: 'México',
    person: 'SWAT',
    email: 'swat@masteredtrax.com',
    phone: '+52 33 2432 8573',
    phoneHref: 'tel:+523324328573',
  },
  {
    dept: 'Press & Demos',
    city: 'Global',
    person: 'A&R Desk',
    email: 'demos@masteredtrax.com',
    phone: null,
    phoneHref: null,
  },
];

function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: 'General', message: '' });
  const [sent, setSent] = useState(false);

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nSubject: ${form.subject}\n\n${form.message}`
    );
    window.location.href = `mailto:joe@masteredtrax.com?subject=${encodeURIComponent(`[Contact] ${form.subject} — ${form.name}`)}&body=${body}`;
    setSent(true);
  };

  return (
    <div className="mt-contact">
      <section className="mt-contact__intro">
        <div className="mt-container mt-contact__introInner">
          <aside className="mt-contact__aside">
            <span className="mt-kicker">Sólo consultas serias</span>
            <p>
              Si tienes una pregunta o propuesta, escríbenos. Leemos cada
              mensaje — y respondemos a los que coinciden con nuestro trabajo.
            </p>
          </aside>
          <div className="mt-contact__hero">
            <h2>
              Empieza<br />
              <em>la conversación.</em>
            </h2>
            <ul className="mt-contact__quick">
              <li>
                <span className="mt-kicker">General</span>
                <a href="mailto:joe@masteredtrax.com">joe@masteredtrax.com</a>
              </li>
              <li>
                <span className="mt-kicker">Press</span>
                <a href="mailto:press@masteredtrax.com">press@masteredtrax.com</a>
              </li>
              <li>
                <span className="mt-kicker">Demos</span>
                <a href="mailto:demos@masteredtrax.com">demos@masteredtrax.com</a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="mt-contact__grid">
        <div className="mt-container">
          <div className="mt-contact__gridHead">
            <span className="mt-eyebrow">Departments · Direct Lines</span>
          </div>
          <ul className="mt-contact__depts">
            {DEPARTMENTS.map((d, i) => (
              <li key={d.dept} className="mt-contact__dept">
                <span className="mt-contact__deptNum">0{i + 1}</span>
                <div className="mt-contact__deptMain">
                  <h3>{d.dept}</h3>
                  <p className="mt-contact__deptCity">{d.city}</p>
                </div>
                <div className="mt-contact__deptPerson">
                  <span className="mt-kicker">Contact</span>
                  <p>{d.person}</p>
                </div>
                <div className="mt-contact__deptLinks">
                  <a href={`mailto:${d.email}`}>{d.email}</a>
                  {d.phone && <a href={d.phoneHref}>{d.phone}</a>}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="mt-contact__form">
        <div className="mt-container mt-contact__formInner">
          <div className="mt-contact__formSide">
            <span className="mt-eyebrow">Escríbenos</span>
            <h2>
              Cuéntanos<br/>
              <em>tu proyecto.</em>
            </h2>
            <p>
              Gestionamos propuestas de management, booking, prensa y
              submissions de demos. Al enviar, abriremos tu cliente de correo
              con el mensaje pre-llenado.
            </p>
            <div className="mt-contact__locations">
              <div>
                <span className="mt-kicker">Oficina MX</span>
                <p>Guadalajara, Jalisco<br/>México</p>
              </div>
              <div>
                <span className="mt-kicker">Oficina US</span>
                <p>Chicago, IL<br/>United States</p>
              </div>
            </div>
          </div>

          <form className="mt-contact__formBody" onSubmit={submit}>
            <div className="mt-contact__row">
              <label>
                <span>Nombre</span>
                <input type="text" value={form.name} onChange={update('name')} required placeholder="Tu nombre completo" />
              </label>
              <label>
                <span>Correo</span>
                <input type="email" value={form.email} onChange={update('email')} required placeholder="name@domain.com" />
              </label>
            </div>
            <label className="mt-contact__field">
              <span>Asunto</span>
              <select value={form.subject} onChange={update('subject')}>
                <option>General</option>
                <option>Management</option>
                <option>USA Booking</option>
                <option>MX Booking</option>
                <option>Press</option>
                <option>Demo Submission</option>
              </select>
            </label>
            <label className="mt-contact__field">
              <span>Mensaje</span>
              <textarea rows="6" value={form.message} onChange={update('message')} required placeholder="Cuéntanos sobre el proyecto, fechas, contexto..." />
            </label>
            <div className="mt-contact__submitRow">
              <span className="mt-contact__fine">Al enviar aceptas nuestra política de privacidad.</span>
              <button type="submit" className="mt-btn mt-btn--primary">
                <span>{sent ? 'Enviado · Gracias' : 'Enviar mensaje'}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </form>
        </div>
      </section>

      <section className="mt-contact__socials">
        <div className="mt-container mt-contact__socialsInner">
          <span className="mt-kicker">Follow the label</span>
          <div className="mt-contact__socialsRow">
            <a href="https://www.instagram.com/masteredtrax/" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://www.youtube.com/@MasteredTraxVEVO" target="_blank" rel="noopener noreferrer">YouTube</a>
            <a href="https://www.facebook.com/OfficialMasteredTrax" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://twitter.com/MasteredTrax" target="_blank" rel="noopener noreferrer">X / Twitter</a>
            <a href="https://masteredtrax.shop" target="_blank" rel="noopener noreferrer">Shop</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
